import { apiClient, handleResp } from './utils';
export default {
  doSetConfig(data) {
    return handleResp(apiClient().post('/set_config', data));
  },
  doSetConfigVar(data) {
    return handleResp(apiClient().post('/set_config_var', data));
  },
  getConfig() {
    return handleResp(apiClient().get('/get_config'));
  },
  getConfigVar(key) {
    return handleResp(apiClient().post('/get_config_var', { key }));
  },
  getInstructionVideos() {
    return handleResp(apiClient().get('/get_instruction_videos'));
  },
  doUpdateInstructionVideo(data) {
    return handleResp(apiClient().post('/set_instruction_video', data));
  },
};
